export default class SessionExpiredError extends Error {
  constructor() {
    super();
    this.name = 'SessionExpiredError';
    this.message = 'Sessão expirada';
  }
}
